import React from 'react';
import { Divider, Modal as AntdModal, ModalProps, theme } from 'antd';

interface Props extends Omit<ModalProps, 'title'> {
  title: React.ReactNode;
  children?: React.ReactNode;
}

export default function Modal({ title, children, ...props }: Props) {
  const { token } = theme.useToken();
  return (
    <AntdModal
      closable={false}
      title={
        <Divider
          orientation="left"
          style={{ borderTop: token.colorPrimary, marginTop: 0 }}
        >
          {title}
        </Divider>
      }
      {...props}
    >
      {children}
    </AntdModal>
  );
}
